import { ReactElement } from "react";
import styles from "./EditRssTileFeedInfo.module.less";

export type EditRssTileFeedInfoProps = {
	title: string;
	text: string;
};

export const EditRssTileFeedInfo = (props: EditRssTileFeedInfoProps): ReactElement => (
	<div className={styles.root}>
		<label className={styles.title}>{props.title}</label>
		<p className={styles.text}>{props.text}</p>
	</div>
);

EditRssTileFeedInfo.displayName = "EditRssTileFeedInfo";